// Tax Invoice Request (SZP/CAN) 공용 헬퍼

// 신청 불가 상태 코드 -> 메시지 i18n 키 (코드값은 사양 확정 후 변경될 수 있음)
//  REQUESTED         : Request/Processing 상태의 Tax Invoice Request 존재
//  MONTHLY_CREATED   : Monthly Invoice Create 되었으나 Confirm 전
//  MONTHLY_CONFIRMED : Monthly Invoice Create + Confirm 완료
//  NOT_ELIGIBLE      : 정상 청구 운임 없음 또는 Monthly Invoice 대상 아님
export function taxInvoiceFailMessageKey (status) {
  switch (status) {
    case 'REQUESTED':
      return 'msg.ADD20260813.003'
    case 'MONTHLY_CREATED':
      return 'msg.ADD20260813.004'
    case 'MONTHLY_CONFIRMED':
      return 'msg.ADD20260813.005'
    default:
      return 'msg.ADD20260813.006'
  }
}
